import React, { ReactNode } from "react";
import { Layout as LandingPageLayout } from "antd";
import Header from "@/components/LandingPage/Header";
import Footer from "@/components/LandingPage/Footer";
import BackToTop from "@/components/LandingPage/BackToTop";
const { Content } = LandingPageLayout;

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <LandingPageLayout className="min-h-screen">
      <Header />
      <Content className="flex-grow">{children}</Content>
      <Footer />
      <BackToTop />
    </LandingPageLayout>
  );
};

export default Layout;
